import axios from "axios";

const API_BASE_URL =
  localStorage.getItem("CF_BASE_URL")?.replace("/admin", "") ||
  process.env.VUE_APP_BASE_URL?.replace("/admin", "") ||
  "https://sass-api-pre-prod.dimitra.dev/api";

/**
 * Standalone-survey consumer API (sub-organization side).
 * Backed by the top-level /surveys routes (separate from ESG).
 */
export default {
  // Surveys assigned to the caller's sub-organization.
  async getAssignedSurveys(params) {
    return axios
      .get(`${API_BASE_URL}/surveys`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // Question headings + questions + existing responses for a survey.
  async getSurveyQuestions(assessmentId, params) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/questions`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // Single question (with options / getDataQuestions / actionPlans) + the
  // sub-organization's existing response(s) for it.
  async getSurveyQuestionById(assessmentId, params) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/question`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // Save (create/update) a response for a survey question. Accepts a single object or an array.
  async saveSurveyResponse(payload) {
    return axios
      .post(`${API_BASE_URL}/surveys/save-response`, payload)
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // --- Admin "view responses" (org-scoped) ---------------------------------

  // Submissions table for a survey (page/limit/search).
  async getSurveySubmissions(assessmentId, params) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/submissions`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // One submission's full answers, grouped by heading.
  async getSurveySubmissionDetail(assessmentId, submissionId) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/submissions/${submissionId}`)
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // Per-question aggregate across all submissions (summary view).
  async getSurveyResponsesSummary(assessmentId, params) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/responses-summary`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  // Per-question respondent breakdown (responses-by-question view).
  async getSurveyResponsesByQuestion(assessmentId, params) {
    return axios
      .get(`${API_BASE_URL}/surveys/${assessmentId}/responses-by-question`, { params })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
};
